'use strict';
var novicell = novicell || {};

novicell.sliders = novicell.sliders || function () {

	function init() {
		var sliders = document.querySelectorAll('.js-slider');

		if ( sliders ) {
			sliderFunction(sliders);
		}
	}

	function sliderFunction(sliders) {
		for (var i = 0; i < sliders.length; i++) {
			let slider 				= sliders[i],
				slider_wrapper 		= slider.querySelector('.js-slider__wrapper'),
				slider_items		= slider.querySelectorAll('.js-slider-item'),
				slider_nav_prev 	= slider.querySelector('.js-slider-btn.prev'),
				slider_nav_next 	= slider.querySelector('.js-slider-btn.next');

			// Init Siema slider
			let siema_slider = new Siema({
			    selector: slider_wrapper,
			    perPage: 1,
			    loop: false,
			    duration: 500,
			    draggable: false,
			    easing: 'cubic-bezier(0.77, 0, 0.175, 1)',
			    onInit: sliderInit,
			    onChange: sliderOnChange
			});

			if ( slider_nav_prev && slider_nav_next ) {
				// Call slider navigation function
				sliderNavigation(siema_slider, slider_nav_prev, slider_nav_next);
			}


			// Call slider navigation function
			siema_slider.setAutoHeight();

		};
	}

	Siema.prototype.setAutoHeight = function () {
		
	    var that, timeout;
	    
	    that = this;
	    
	    function autoHeight() {
	    	
	        var currentItems, min, max, itemHeightList, height, maxHeight, i;
	        
	    	min = that.currentSlide;
	        max =  min + that.perPage;
	        itemHeightList = [];

	        for (i = min; i < max; i++) {
	            height = parseInt(that.innerElements[i].scrollHeight, 10);
	            itemHeightList.push(height);
	        }

	        maxHeight = Math.max.apply(null, itemHeightList);

	        that.sliderFrame.style.maxHeight = maxHeight + 'px';
	    }
	    
	    window.addEventListener('resize', function () {
	        that.sliderFrame.style.maxHeight = '';
	        clearTimeout(timeout);
	        timeout = setTimeout(autoHeight, 500);
	    });
	    autoHeight();
	};

	function sliderInit() {
		var slider = this.selector,
			i = this.currentSlide,
			slides_amount = this.innerElements.length;

		// Check if already has class "loaded", else add it
	    if ( !slider.classList.contains('loaded') ) {
	        slider.classList.add('loaded');
	    }

	    this.innerElements[i].classList.add('active');

	    navState(slides_amount, i, this);
	}

	function sliderOnChange() {
	    var current = this.currentSlide,
	        elements = this.innerElements,
	        current_label = current + 1, 
	        slider_current = this.selector.parentNode.querySelector('.js-slider__nav .slider-nav__label .current');

	    this.setAutoHeight();

	    slider_current.innerHTML = current_label++ + ' ';

	    for (var i = 0; i < elements.length; i++) {
	    	if ( i == current ) {
	    		// Add active class to the current slide
	    	 	elements[i].classList.add('active');
	    	} else {
	    		// Remove the active class if not the current slide
	    		elements[i].classList.remove('active');
	    	}

	    	navState(i, current, this);
	    }
	}

	function sliderNavigation(slider, prev, next) {
		// Previous Siema slide
		prev.addEventListener('click', function(e) {
			e.stopPropagation();

		    slider.prev();
		});

		// Next Siema slide
		next.addEventListener('click', function(e) {
			e.stopPropagation();

		    slider.next();
		});
	}

	function navState(i, current, slider) {
		var nav_prev = slider.selector.parentNode.querySelector('.js-slider-btn.prev'),
			nav_next = slider.selector.parentNode.querySelector('.js-slider-btn.next'),
			current_nav_item = slider.selector.parentNode.parentNode.querySelector('.js-slider__nav .slider-nav-item[data-nav-item="' + i + '"]');

		if ( nav_prev && nav_next ) {
			(i == current)
				? nav_next.classList.add('disabled')
				: nav_next.classList.remove('disabled');

			( 0 == current )
				? nav_prev.classList.add('disabled')
				: nav_prev.classList.remove('disabled');
		}

		if ( current_nav_item ) {
			( i == current )
				? current_nav_item.classList.add('active')
				: current_nav_item.classList.remove('active');
		}
	}

	return {
		init : init
	};

}();